var _path, _path2, _path3, _rect, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllTestsAreFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 230,
    viewBox: "0 0 220 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.427734 180.411H219.565V214.887C219.565 223.234 212.799 230 204.452 230H15.5407C7.19401 230 0.427734 223.234 0.427734 214.887V180.411Z",
    fill: "#D1C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.427734 72.731H219.565V184.189L202.091 201.663L184.853 219.137H16.0129C7.40546 219.137 0.427734 212.16 0.427734 203.552V72.731Z",
    fill: "#EAE8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.427734 34.9486C0.427734 26.602 7.19403 19.8357 15.5407 19.8357H204.452C212.799 19.8357 219.565 26.602 219.565 34.9486V67.0636H0.427734V34.9486Z",
    fill: "#FF970E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.427734,
    y: 67.0637,
    width: 219.138,
    height: 5.66735,
    fill: "#D1C9C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.197 189.856C183.197 185.944 186.369 182.772 190.281 182.772H219.563V184.189L184.85 219.137H183.197V189.856Z",
    fill: "#BCB3B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 87.3716,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 87.3716,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 87.3718,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 87.3718,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 87.3716,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 87.3716,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 128.932,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 128.932,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 128.932,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 128.932,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 128.932,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 128.932,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 161.477,
    y: 128.932,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 161.477,
    y: 128.932,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 170.492,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1328,
    y: 170.492,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 170.492,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 74.584,
    y: 170.492,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 170.492,
    width: 26.9199,
    height: 24.5585,
    rx: 3.77823,
    fill: "#75797E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 118.029,
    y: 170.492,
    width: 23.1417,
    height: 24.5585,
    rx: 3.77823,
    fill: "#939598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.492 99.6506L172.688 106.621C172.883 106.811 173.198 106.796 173.375 106.589L185.564 92.3303",
    stroke: "#1AC057",
    strokeWidth: 8.02875,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.967,
    cy: 39.6713,
    r: 7.08419,
    fill: "#C37104"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.002,
    cy: 39.6713,
    r: 7.08419,
    fill: "#C37104"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.041,
    cy: 39.6713,
    r: 7.08419,
    fill: "#C37104"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9434 43.9035C52.2807 43.6844 53.9978 41.612 53.7787 39.2748C53.5595 36.9375 51.4872 35.2205 49.15 35.4396L49.9434 43.9035ZM46.8508 5.36239L44.9499 1.56062L46.8508 5.36239ZM46.2407 32.7903V12.171H37.7397V32.7903H46.2407ZM47.8072 9.63645L48.7517 9.16417L44.9499 1.56062L44.0054 2.03289L47.8072 9.63645ZM51.2862 9.16417L52.2308 9.63645L56.0326 2.03289L55.088 1.56062L51.2862 9.16417ZM53.7972 12.171V19.8358H62.2982V12.171H53.7972ZM52.2308 9.63645C53.1908 10.1164 53.7972 11.0976 53.7972 12.171H62.2982C62.2982 7.87769 59.8726 3.9529 56.0326 2.03289L52.2308 9.63645ZM48.7517 9.16417C49.5495 8.76529 50.4885 8.76529 51.2862 9.16417L55.088 1.56062C51.897 -0.0348983 48.141 -0.0348976 44.9499 1.56062L48.7517 9.16417ZM46.2407 12.171C46.2407 11.0976 46.8472 10.1164 47.8072 9.63645L44.0054 2.03289C40.1654 3.9529 37.7397 7.87769 37.7397 12.171H46.2407ZM49.15 35.4396C47.5892 35.5859 46.2407 34.358 46.2407 32.7903H37.7397C37.7397 39.3664 43.3961 44.5173 49.9434 43.9035L49.15 35.4396Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.215 43.9035C111.552 43.6844 113.269 41.612 113.05 39.2748C112.831 36.9375 110.759 35.2205 108.421 35.4396L109.215 43.9035ZM106.122 5.36239L104.221 1.56062L106.122 5.36239ZM105.512 32.7903V12.171H97.0112V32.7903H105.512ZM107.079 9.63645L108.023 9.16417L104.221 1.56062L103.277 2.03289L107.079 9.63645ZM110.558 9.16417L111.502 9.63645L115.304 2.03289L114.359 1.56062L110.558 9.16417ZM113.069 12.171V19.8358H121.57V12.171H113.069ZM111.502 9.63645C112.462 10.1164 113.069 11.0976 113.069 12.171H121.57C121.57 7.87769 119.144 3.9529 115.304 2.03289L111.502 9.63645ZM108.023 9.16417C108.821 8.76529 109.76 8.76529 110.558 9.16417L114.359 1.56062C111.168 -0.0348983 107.412 -0.0348976 104.221 1.56062L108.023 9.16417ZM105.512 12.171C105.512 11.0976 106.119 10.1164 107.079 9.63645L103.277 2.03289C99.4369 3.9529 97.0112 7.87769 97.0112 12.171H105.512ZM108.421 35.4396C106.861 35.5859 105.512 34.358 105.512 32.7903H97.0112C97.0112 39.3664 102.668 44.5173 109.215 43.9035L108.421 35.4396Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.719 43.9035C171.056 43.6844 172.773 41.612 172.554 39.2748C172.335 36.9375 170.263 35.2205 167.925 35.4396L168.719 43.9035ZM165.626 5.36239L163.725 1.56062L165.626 5.36239ZM165.016 32.7903V12.171H156.515V32.7903H165.016ZM166.583 9.63645L167.527 9.16417L163.725 1.56062L162.781 2.03289L166.583 9.63645ZM170.062 9.16417L171.006 9.63645L174.808 2.03289L173.863 1.56062L170.062 9.16417ZM172.573 12.171V19.8358H181.074V12.171H172.573ZM171.006 9.63645C171.966 10.1164 172.573 11.0976 172.573 12.171H181.074C181.074 7.87769 178.648 3.9529 174.808 2.03289L171.006 9.63645ZM167.527 9.16417C168.325 8.76529 169.264 8.76529 170.062 9.16417L173.863 1.56062C170.672 -0.0348983 166.916 -0.0348976 163.725 1.56062L167.527 9.16417ZM165.016 12.171C165.016 11.0976 165.623 10.1164 166.583 9.63645L162.781 2.03289C158.941 3.9529 156.515 7.87769 156.515 12.171H165.016ZM167.925 35.4396C166.365 35.5859 165.016 34.358 165.016 32.7903H156.515C156.515 39.3664 162.171 44.5173 168.719 43.9035L167.925 35.4396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTestsAreFailed);
export default __webpack_public_path__ + "static/media/all-tests-are-failed.8054038785ef3e8c608290dd6863efd5.svg";
export { ForwardRef as ReactComponent };